import React from "react";
import { Link } from "react-router-dom";
import { Search, Ticket, PartyPopper } from "lucide-react";

const STEPS = [
  { n: "1", icon: Search, title: "Discover", desc: "Filter by city, vibe, or price. Every kind of event, one feed." },
  { n: "2", icon: Ticket, title: "Book", desc: "UPI or card, QR ticket in your inbox. Under sixty seconds." },
  { n: "3", icon: PartyPopper, title: "Vibe", desc: "Match with the crowd, find your photos, chase the after-party." },
];

/**
 * HowItWorks — quiet three-column editorial section.
 * No huge transparent numbers, no colour tiles.  Type + rule + type.
 */
export default function HowItWorks() {
  return (
    <section className="border-b border-line" data-testid="how-it-works">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-16 md:py-24">
        <div className="grid md:grid-cols-[1fr_1.5fr] gap-8 md:gap-16">
          <div>
            <div className="text-[10px] font-mono tracking-[0.35em] uppercase text-magenta">Method</div>
            <h2 className="mt-3 font-fancy text-4xl md:text-5xl leading-[0.92]">Three moves.<br />Zero drama.</h2>
            <p className="text-sm text-muted mt-5 max-w-sm">From "there's a show tonight" to "I made memories". No tabs to keep open, no group-chat drama.</p>
            <Link to="/#events-grid" className="mt-6 btn-primary inline-flex" data-testid="hiw-cta">Start exploring</Link>
          </div>
          <div>
            <div className="grid md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-white/10 border-t border-white/10 border-b">
              {STEPS.map((s) => (
                <div key={s.n} className="p-6" data-testid={`hiw-step-${s.n}`}>
                  <div className="flex items-center justify-between">
                    <s.icon className="w-5 h-5 text-lime" strokeWidth={2.5} />
                    <span className="font-fancy text-3xl text-white/25">0{s.n}</span>
                  </div>
                  <div className="mt-6 font-heading font-bold text-lg uppercase tracking-tight">{s.title}</div>
                  <div className="text-sm text-muted mt-2 leading-relaxed">{s.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
